import { lazy, Suspense } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const DistributionDetailPage = lazy(() => import("./DistributionDetailPage"));

const distributionsRoutes: RouteObject[] = [
  {
    path: "/distributions/:distributionId",
    element: (
      <Suspense fallback={<Loading />}>
        <DistributionDetailPage />
      </Suspense>
    ),
  },
];

export default distributionsRoutes;
